// extracted by mini-css-extract-plugin
module.exports = {"slide":"list_slide_-thlw","slide-reverse":"list_slide-reverse_3E1Jg","pageContent":"list_pageContent_29LiX","card-wrapper":"list_card-wrapper_1E56d","footer":"list_footer_1961q"};